import { Skeleton } from 'antd'
import { Fragment } from 'react'
import { useFormContext } from 'react-hook-form'
import { EMediaCategory } from 'src/interfaces/gallery'
import MetaTab from 'src/pages/blog/content/MetaTab'
import { IWorkshopEventSchema } from 'src/pages/event-management/WorkshopAndEventFormPage/schema'

interface IAboutUsPageSeoProps {
  activeTab: string
  isGettingDetail?: boolean
}

export const EventSeo = ({
  activeTab,
  isGettingDetail,
}: IAboutUsPageSeoProps) => {
  const { control, getValues, setValue } =
    useFormContext<IWorkshopEventSchema>()

  return (
    <Fragment>
      {isGettingDetail ? (
        <Skeleton
          paragraph={{ rows: 4 }}
          style={{
            marginTop: 10,
          }}
        />
      ) : (
        <div data-aos="fade-right" className="bg-white">
          <MetaTab
            activeTab={activeTab}
            control={control}
            getValues={getValues}
            setValue={setValue}
            isShowSelectMedia
            category={EMediaCategory.CONTENT}
          />
        </div>
      )}
    </Fragment>
  )
}
